import React, { Component } from 'react';
import { Query } from 'react-apollo';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';

import styles from './ReschedulePage.scss';

import ArrowLeftC from '../../../legacyCore/icons/ArrowLeftC';
import RescheduleForm, {
  AppointmentImminentWarning,
  AppointmentNonReschedulableWarning,
  AppointmentPassedWarning,
  AppointmentUnavailableWarning,
  query,
} from '../../../shared/components/RescheduleForm';
import Unauthorized from '../../../shared/components/Unauthorized';

import {
  hasPassed,
  isImminent,
  isReschedulable,
  isUnavailable,
} from '../../../shared/utils/appointmentUtils';
import isForbidden from '../../../shared/utils/isForbidden';
import { buildAppointmentUrl, getQueryFromLocation } from '../../../shared/utils/urls';
import MainLayout from '../../components/MainLayout/MainLayoutWithData';
import LoadingPage from '../LoadingPage';
import NotFoundPage from '../NotFoundPage';

export default class ReschedulePage extends Component {
  render() {
    const {
      match: { params },
      history: { location },
    } = this.props;
    const locationquery = getQueryFromLocation(location);

    return (
      <Query query={query} variables={{ id: params.id, patientToken: locationquery.token }}>
        {({ data, loading, error }) => {
          if (loading) return <LoadingPage />;
          if (isForbidden(error))
            return (
              <Unauthorized>
                <LoadingPage />
              </Unauthorized>
            );
          if (error) return <MainLayout error={error} />;
          if (!data || !data.appointment) return <NotFoundPage />;

          const { appointment } = data;
          const { phone } = appointment.provider.office;
          const unavailable = isUnavailable(appointment);
          const appointmentUrl = buildAppointmentUrl(appointment.provider.id, appointment.id, {
            patientToken: appointment.patientToken,
            useMainLayout: true,
          });
          let content;
          if (hasPassed(appointment)) {
            content = <AppointmentPassedWarning phone={phone} />;
          } else if (isImminent(appointment)) {
            content = <AppointmentImminentWarning phone={phone} />;
          } else if (isReschedulable(appointment)) {
            content = <RescheduleForm appointment={appointment} useMainLayout />;
          } else {
            content = <AppointmentNonReschedulableWarning phone={phone} />;
          }
          return (
            <MainLayout>
              <Helmet>
                <title>Reschedule Your Appointment</title>
                <meta name="robots" content="noindex" />
              </Helmet>
              <div className={styles['reschedule-page__row']}>
                {!unavailable && (
                  <p className="margin-bottom-none font-size-xs">
                    <Link to={appointmentUrl}>
                      <ArrowLeftC /> Back to Appointment Details
                    </Link>
                  </p>
                )}
                <h1 className={styles['reschedule-page__title']}>
                  {unavailable
                    ? 'Shoot, someone took your appointment while we were waiting for you to verify.'
                    : 'Reschedule your Appointment'}
                </h1>
                {unavailable && <AppointmentUnavailableWarning marginBottom="md" />}
                {content}
              </div>
            </MainLayout>
          );
        }}
      </Query>
    );
  }
}
